import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// reference: https://material.angular.io/guide/getting-started#step-5-gesture-support
// hammerjs is needed for a complete gesture support
import 'hammerjs';
import './vendor'; // libs and polyfills (CM)
// tslint:disable-next-line:ordered-imports
import './app/index'; // ng1 app - TODO: remove once angularjs has been removed from project (CM)
import { AppModule } from './ng2/app.module';

// Disable Angular's development mode, which turns off assertions and other checks within the framework (CM).
if (process && process.env && process.env.RELEASE) enableProdMode();

// bootstrap NG2 App (CM).
platformBrowserDynamic().bootstrapModule(AppModule);
